import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Avatar, IconButton, Box, Button } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
import { Notification01Icon } from '@hugeicons/core-free-icons';
import { useLocation, useNavigate } from 'react-router-dom';

const Navbar = ({ sidebarWidth }) => {
    const [username, setUsername] = useState('');
    const [userimg, setUserimg] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        const storedUsername = localStorage.getItem('username');
        const storedAvatar = localStorage.getItem('avatar');

        if (!token) {
            window.location.href = '/';
        } else {
            setUsername(storedUsername || '');
            setUserimg(storedAvatar || '');
        }
    }, []);

    const handleProfileClick = () => {
        const storedUserId = localStorage.getItem("user_id");
        if (storedUserId) {
            navigate(`/profile/${storedUserId}`);
        } else {
            console.error("User ID not found in localStorage");
        }
    };

    const handleDiaryClick = () => {
    navigate("/diary");
  };

  // 👇 hide button if current path is '/diary'
  const showDiaryButton = location.pathname !== "/diary";


    return (
        <AppBar position="fixed" elevation={0}
            sx={{
                width: `calc(100% - ${sidebarWidth}px - 16px)`,
                ml: `calc(${sidebarWidth}px + 16px)`,
                bgcolor: '#fff', color: '#222', boxShadow: 'none', zIndex: 1100,
                transition: 'width 0.2s, margin-left 0.2s',
                borderRadius: 4,
            }}>
            <Toolbar sx={{ minHeight: 80, display: 'flex', justifyContent: 'space-between', px: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    {showDiaryButton && (
            <Button
              onClick={handleDiaryClick}
              sx={{
                bgcolor: "#3670ea",
                borderRadius: 20,
                px: 3,
                py: 1,
                color: '#fff',
                fontWeight: 500,
                fontSize: 14,
                textTransform: 'none',
                '&:hover': { bgcolor: '#2f63d5' },
              }}
            >
              + Create new diary
            </Button>
          )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton>
                        <HugeiconsIcon icon={Notification01Icon} size={20} />
                    </IconButton>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', }} onClick={handleProfileClick}>
                        <Avatar src={userimg || undefined} sx={{ width: 30, height: 30 }} />
                        <Typography sx={{ fontWeight: 600, color: '#66676b' }}>{username}</Typography>
                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;